// extracted by mini-css-extract-plugin
export default {"loading":"LoginLoader_loading__9dEN-"};